// extracted by css-extract-rspack-plugin
export default {"root":"root-rf064T","resultsCount":"resultsCount-mSbK70"};